import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteBlockArguments {
  params: OpalApiRequestParams<'DeleteBlockV3'>
}

export async function deleteBlock({
  params,
}: DeleteBlockArguments): Promise<null> {
  const url = new URL(
    `/loupe/v3/blocks/${params.path.block_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
